// src/services/serviceService.js
import api from '../utils/api';// Your API instance

const SERVICE_BASE_URL = '/services';

const serviceService = {
  // Get all services with pagination, filtering, and search
  getServices: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add search
      if (params.search) queryParams.append('search', params.search);
      
      // Add filters
      if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
      
      // Add sorting
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

      const response = await api.get(`${SERVICE_BASE_URL}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get single service by ID
  getServiceById: async (id) => {
    try {
      const response = await api.get(`${SERVICE_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new service
  createService: async (serviceData) => {
    try {
      const response = await api.post(SERVICE_BASE_URL, serviceData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update service
  updateService: async (id, serviceData) => {
    try {
      const response = await api.put(`${SERVICE_BASE_URL}/${id}`, serviceData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Partial update service
  patchService: async (id, serviceData) => {
    try {
      const response = await api.patch(`${SERVICE_BASE_URL}/${id}`, serviceData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete service
  deleteService: async (id) => {
    try {
      const response = await api.delete(`${SERVICE_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get agencies using this service
  getServiceAgencies: async (serviceId, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      const response = await api.get(
        `${SERVICE_BASE_URL}/${serviceId}/agencies?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Toggle service status
  toggleServiceStatus: async (id) => {
    try {
      const response = await api.patch(`${SERVICE_BASE_URL}/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Bulk delete services
  bulkDeleteServices: async (ids) => {
    try {
      const response = await api.delete(`${SERVICE_BASE_URL}/bulk`, { data: { ids } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Export services
  exportServices: async (format = 'csv', filters = {}) => {
    try {
      const response = await api.get(`${SERVICE_BASE_URL}/export/${format}`, {
        params: filters,
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get service statistics
  getServiceStats: async () => {
    try {
      const response = await api.get(`${SERVICE_BASE_URL}/stats`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get popular services
  getPopularServices: async (limit = 10) => {
    try {
      const response = await api.get(`${SERVICE_BASE_URL}/popular?limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default serviceService;